import { CardButtonProps } from '../content-card.constants';
import { SecondaryButton } from 'approot/shared/styles/buttons/buttons';
import { PrimaryButton } from 'approot/shared/styles/buttons/primary-button.style';

export const CardButton = ({ primary, text, ...rest }: CardButtonProps) =>
  primary ? (
    <PrimaryButton {...rest}>{text}</PrimaryButton>
  ) : (
    <SecondaryButton {...rest}>{text}</SecondaryButton>
  );
